var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0725 11.3754C11.0976 11.4682 11.1111 11.5659 11.1111 11.6666V12.2222C11.1111 12.8358 10.6136 13.3333 9.99995 13.3333C9.3863 13.3333 8.88883 12.8358 8.88883 12.2222V11.6666C8.88883 11.5659 8.90225 11.4682 8.92738 11.3754C7.69316 11.2817 6.46827 11.0261 5.285 10.6084L5.00037 10.508C4.56637 10.3548 4.33872 9.87882 4.4919 9.44482C4.64507 9.01082 5.12107 8.78317 5.55507 8.93634L5.8397 9.0368C8.53182 9.98696 11.4681 9.98696 14.1602 9.0368L14.4448 8.93634C14.8788 8.78317 15.3548 9.01082 15.508 9.44482C15.6612 9.87882 15.4335 10.3548 14.9995 10.508L14.7149 10.6084C13.5316 11.0261 12.3067 11.2817 11.0725 11.3754Z",
    fill: "#71869D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.11106 4.99995V4.72217C6.11106 3.34146 7.23034 2.22217 8.61106 2.22217H11.3888C12.7695 2.22217 13.8888 3.34146 13.8888 4.72217V4.99995H14.1666C16.161 4.99995 17.7777 6.6167 17.7777 8.61106V14.1666C17.7777 16.161 16.161 17.7777 14.1666 17.7777H5.83328C3.83892 17.7777 2.22217 16.161 2.22217 14.1666V8.61106C2.22217 6.61669 3.83892 4.99995 5.83328 4.99995H6.11106ZM7.77772 4.72217C7.77772 4.26193 8.15082 3.88883 8.61106 3.88883H11.3888C11.8491 3.88883 12.2222 4.26193 12.2222 4.72217V4.99995H7.77772V4.72217ZM5.83328 6.66661C4.75939 6.66661 3.88883 7.53717 3.88883 8.61106V14.1666C3.88883 15.2405 4.75939 16.1111 5.83328 16.1111H14.1666C15.2405 16.1111 16.1111 15.2405 16.1111 14.1666V8.61106C16.1111 7.53717 15.2405 6.66661 14.1666 6.66661H5.83328Z",
    fill: "#71869D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWork);
export default __webpack_public_path__ + "static/media/iconWork.886912a93f8f0d93fc884be3693a3958.svg";
export { ForwardRef as ReactComponent };